var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 8,
    fill: "#E74C3C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 8,
    fill: "#E74C3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 15H24.5L23.45 13.6C23.3103 13.4137 23.1291 13.2625 22.9208 13.1584C22.7125 13.0542 22.4829 13 22.25 13H19.75C19.5171 13 19.2875 13.0542 19.0792 13.1584C18.8709 13.2625 18.6897 13.4137 18.55 13.6L17.5 15H14.25C14.1837 15 14.1201 15.0263 14.0732 15.0732C14.0263 15.1201 14 15.1837 14 15.25V15.75C14 15.8163 14.0263 15.8799 14.0732 15.9268C14.1201 15.9737 14.1837 16 14.25 16H14.8406L15.8781 27.6344C15.9117 28.0074 16.0836 28.3544 16.36 28.6071C16.6364 28.8598 16.9974 28.9999 17.3719 29H24.6281C25.0027 28.9999 25.3636 28.8598 25.64 28.6071C25.9164 28.3544 26.0883 28.0074 26.1219 27.6344L27.1594 16H27.75C27.8163 16 27.8799 15.9737 27.9268 15.9268C27.9737 15.8799 28 15.8163 28 15.75V15.25C28 15.1837 27.9737 15.1201 27.9268 15.0732C27.8799 15.0263 27.8163 15 27.75 15ZM19.35 14.2C19.3967 14.1381 19.4572 14.0878 19.5266 14.0531C19.5959 14.0184 19.6724 14.0002 19.75 14H22.25C22.3276 14.0002 22.4041 14.0184 22.4734 14.0531C22.5428 14.0878 22.6033 14.1381 22.65 14.2L23.25 15H18.75L19.35 14.2ZM25.125 27.5437C25.1147 27.6683 25.0579 27.7845 24.9658 27.869C24.8737 27.9536 24.7531 28.0003 24.6281 28H17.3719C17.2469 28.0003 17.1263 27.9536 17.0342 27.869C16.9421 27.7845 16.8853 27.6683 16.875 27.5437L15.8438 16H26.1563L25.125 27.5437Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteButton);
export default __webpack_public_path__ + "static/media/delete-button.ae7c76c28a747ae78e62c0ff1f58d6e9.svg";
export { ForwardRef as ReactComponent };